import { Text } from '@understory-io/leaf/text';
import { css } from '@understory-io/leaf/css';
import { FormattedMessage } from 'react-intl';

/**
 * The prompt shown next to Continue when the visitor tries to move on without
 * a bookable time picked. Shared by every surface that lists time slots so the
 * copy and tone can't drift between the booking dialog and the checkout step.
 */
export function SelectTimeError() {
  return (
    <Text
      as="p"
      role="alert"
      style="body-small-regular"
      className={css({ color: 'status.negative.bold' })}
    >
      {/* Message ids are content hashes of the text plus this description, so
          both are kept verbatim from the booking dialog this moved out of —
          rewording the description alone would orphan every translation. */}
      <FormattedMessage
        defaultMessage="Please select a time to continue."
        description="Booking dialog error when Continue is pressed without choosing an event"
      />
    </Text>
  );
}
